if (!customElements.get('announcement-rotator')) {
  customElements.define('announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.refresh = () => {
        this.stop();
        this.index = 0;
        this.direction = 1;
        this.all = [...this.querySelectorAll('[data-announcement-message]')];
        this.items = this.all.filter(item => item.textContent.trim() && (this.mobile.matches || !item.hasAttribute('data-mobile-only')));
        this.all.forEach(item => { item.hidden = item !== this.items[0]; item.removeAttribute('aria-hidden'); });
        this.dataset.index = '0';
        this.dataset.direction = 'right';
        const left = this.classList.contains('announcement-desktop-left');
        if (this.reduced.matches || this.items.length < 2 || (left && this.mobile.matches)) return;
        this.interval = Math.max(3, Number(this.dataset.interval) || 6) * 1000;
        const bar = this.closest('[data-announcement-trust]');
        const epoch = Number(bar.dataset.rotationEpoch) || Date.now();
        bar.dataset.rotationEpoch = String(epoch);
        const delay = !this.mobile.matches && left ? this.interval / 2 : this.interval;
        this.nextTick = epoch + delay;
        while (this.nextTick <= Date.now()) this.nextTick += this.interval;
        this.schedule();
      };
      this.mobile.addEventListener('change', this.refresh);
      this.reduced.addEventListener('change', this.refresh);
      this.refresh();
    }
    schedule() {
      this.timer = setTimeout(() => {
        if (!document.hidden && !this.contains(document.activeElement)) this.advance();
        this.nextTick += this.interval;
        while (this.nextTick <= Date.now()) this.nextTick += this.interval;
        this.schedule();
      }, Math.max(0, this.nextTick - Date.now()));
    }
    advance() {
      if (this.index === this.items.length - 1) this.direction = -1;
      else if (this.index === 0) this.direction = 1;
      const previous = this.items[this.index];
      this.index += this.direction;
      const next = this.items[this.index];
      this.dataset.index = String(this.index);
      this.dataset.direction = this.direction === 1 ? 'right' : 'left';
      next.hidden = false;
      previous.setAttribute('aria-hidden', 'true');
      const distance = this.direction * 24;
      const timing = { duration:320, easing:'cubic-bezier(.4,0,.2,1)' };
      const outgoing = previous.animate([{ transform:'translateX(0)', opacity:1 }, { transform:`translateX(${distance}px)`, opacity:0 }], timing);
      const incoming = next.animate([{ transform:`translateX(${-distance}px)`, opacity:0 }, { transform:'translateX(0)', opacity:1 }], timing);
      this.animations = [outgoing, incoming];
      Promise.all(this.animations.map(animation => animation.finished)).then(() => {
        previous.hidden = true;
        previous.removeAttribute('aria-hidden');
        this.animations = [];
      }).catch(() => {});
    }
    stop() {
      clearTimeout(this.timer);
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
    }
    disconnectedCallback() {
      this.stop();
      this.mobile?.removeEventListener('change', this.refresh);
      this.reduced?.removeEventListener('change', this.refresh);
    }
  });
}
